// extracted by mini-css-extract-plugin
module.exports = {"notification-container":"notification-container--TuwHI"};